// extracted by mini-css-extract-plugin
export var marquee = "Krhi";
export var root = "mHPg";
export var rootContainer = "_3m5c";
export var rootItem = "EOoF";
export var rootList = "ocnn";
export var rootListDesktop = "J8f6";
export var rootListTicker = "zAdQ";
export var rootMarquee = "CvLR";
export var rootSeparator = "pbhV";
export var rootTicker = "sHWE";